import { render } from "./TextoPuntaNegra.vue?vue&type=template&id=f6a42a8c"
import script from "./TextoPuntaNegra.vue?vue&type=script&lang=js"
export * from "./TextoPuntaNegra.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__